module.exports = __webpack_public_path__ + "static/only-you-2ca0c2a45eb43a759f94ba028dda0b57.png";